import { FeatureToggleService } from '../feature-toggle.service';
import { ManifestClientService } from '../manifest-client.service';

const SEGMENT_USERID_NEW_FORMAT = 'SEGMENT_USERID_NEW_FORMAT';
const SEGMENT_USERID_OLD_FORMAT = 'SEGMENT_USERID_OLD_FORMAT';

class AnalyticsServiceController {
  trackNewStyleEvents: boolean;
  trackOldStyleEvents: boolean;

  constructor() {}

  // Intended to be called on page refresh to seed the Segment client
  // with identity data
  async trackIdentity(): Promise<void> {
    // don't track identify calls at page load at all if we're going to be tracking them with every event
    if(!(await this.shouldTrackBothFormats())) {
      if(await this.shouldTrackNewStyleEvents()) {
        await this.identifyUserNew();
      }
      if(await this.shouldTrackOldStyleEvents()) {
        await this.identifyUserOld();
      }
    }
  }

  getSegmentIntegrations = (company: { _id: string }) => {
    return {
      Amplitude: {
        groups: {
          companyId: company._id
        }
      }
    }
  }

  returnCompanyInfo = (attributes: any, manifest: { company: { _id: any; opportunityId: any; }; user: { _id: any; }; }) => ({
    ...attributes,
    companyId: manifest.company._id,
    fhUserId: manifest.user._id,
    companyOpportunityId: manifest.company.opportunityId || null
  })

  async trackPageView(pageName: string, properties?: object): Promise<void> {
    const manifest = await ManifestClientService.getManifest();
    const amplitudeIntegration = this.getSegmentIntegrations(manifest.company);

    // if(await this.shouldTrackNewStyleEvents()) {
    //   if(await this.shouldTrackBothFormats()) {
    //     await this.identifyUserNew();
    //   }
    //   (window as any).analytics.page(
    //     pageName,
    //     {
    //       companyId: manifest.company._id,
    //       companyOpportunityId: manifest.company.opportunityId,
    //       ...properties
    //     }, { integrations: amplitudeIntegration }
    //   );
    // }

    // if(await this.shouldTrackOldStyleEvents()) {
    //   if(await this.shouldTrackBothFormats()) {
    //     await this.identifyUserOld();
    //   }
      (window as any).analytics.page(pageName, this.returnCompanyInfo(properties, manifest), { integrations: amplitudeIntegration });
    // }
  }

  async trackEvent(eventName: string, attributes: object): Promise<void> {
    const manifest = await ManifestClientService.getManifest();
    const amplitudeIntegration = this.getSegmentIntegrations(manifest.company);

    // if(await this.shouldTrackNewStyleEvents()) {
    //   if(await this.shouldTrackBothFormats()) {
    //     await this.identifyUserNew();
    //   }

    //   (window as any).analytics.track(eventName, attributes, { integrations: amplitudeIntegration });
    // }

    // if(await this.shouldTrackOldStyleEvents()) {
    //   if(await this.shouldTrackBothFormats()) {
    //     await this.identifyUserOld();
    //   }
      (window as any).analytics.track(eventName, this.returnCompanyInfo(attributes, manifest), { integrations: amplitudeIntegration });
    // }
  }

  private async shouldTrackBothFormats(): Promise<boolean> {
    return await this.shouldTrackNewStyleEvents() &&
      await this.shouldTrackOldStyleEvents();
  }

  private async shouldTrackNewStyleEvents(): Promise<boolean> {
    if(this.trackNewStyleEvents === undefined) {
      this.trackNewStyleEvents = await FeatureToggleService.isToggleEnabled(SEGMENT_USERID_NEW_FORMAT);
    }
    return this.trackNewStyleEvents;
  }

  private async shouldTrackOldStyleEvents(): Promise<boolean> {
    if(this.trackOldStyleEvents === undefined) {
      this.trackOldStyleEvents = await FeatureToggleService.isToggleEnabled(SEGMENT_USERID_OLD_FORMAT);
    }
    return this.trackOldStyleEvents;
  }

  private async identifyUserNew(): Promise<void> {
    const manifest = await ManifestClientService.getManifest();
    const amplitudeIntegration = this.getSegmentIntegrations(manifest.company);
    (window as any).analytics.identify(
      manifest.user._id,
      {
        userName: manifest.user.email,
        firstName: manifest.user.firstName,
        lastName: manifest.user.lastName,
        email: manifest.user.email,
        language: manifest.user.language,
        userTimezone: manifest.user.timezone,
        userType: manifest.user.isInternal ? 'Internal': 'External',
        userRole: manifest.user.role,
        createdAt: manifest.user.createdAt,
        companyId: manifest.company._id,
        fhUserId: manifest.user._id,
        companyOpportunityId: manifest.company.opportunityId || null
      }, { integrations: amplitudeIntegration, userId: manifest.user._id }
    );
    this.identifyGroup();
  }

  private async identifyGroup(): Promise<void> {
    const manifest = await ManifestClientService.getManifest();
    const amplitudeIntegration = this.getSegmentIntegrations(manifest.company);
      (window as any).analytics.group(
        manifest.company._id,
        {
            groupType: 'company',
            groupId: manifest.company._id,
            companyName: manifest.company.name,
            companyId: manifest.company._id,
            fhUserId: manifest.user._id,
            companyOpportunityId: manifest.company.opportunityId || null
        }, { integrations: amplitudeIntegration }
      );
  }

  async identifyUserOld() {
    const manifest = await ManifestClientService.getManifest();
    const amplitudeIntegration = this.getSegmentIntegrations(manifest.company);
    (window as any).analytics.identify(`${manifest.user.email} (${manifest.user._id}) ${manifest.company.name}`, {
      companyCountry: manifest.company.country,
      companyCreationDate: new Date(manifest.company.created),
      companyId: manifest.company._id,
      fhUserId: manifest.user._id,
      companyOpportunityId: manifest.company.opportunityId || null,
      email: manifest.user.email,
      entitlements: this.formatEntitlements(manifest),
      firstName: manifest.user.firstName,
      lastName: manifest.user.lastName,
      userId: manifest.user._id,
      userRole: manifest.user.role,
      userTimezone: manifest.user.timezone,
      userType: manifest.user.isInternal ? 'Internal': 'External'
    }, { integrations: amplitudeIntegration })
  }

  formatEntitlements(manifest) {
    const formattedEntitlements = {};
    Object.keys(manifest.entitlements.v6).forEach((key) => {
      formattedEntitlements[key] = manifest.entitlements.v6[key]?.value;
    });

    return formattedEntitlements;
  }
}

export const AnalyticsService = new AnalyticsServiceController();
